import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { PageError } from "src/common/components";
import { IAppReduxState, IExtendedUser, IUserRole, UserRoles } from "src/common/types";
import { checkUserPermissions } from "src/helpers";
import Routes from "src/common/Routes";
import { LocalesContext } from "src/common/contexts";
interface IStateProps {
  userRole: IUserRole;
}
type Props = IStateProps;
const TemplatesView = ({ userRole }: Props) => {
  const { t } = useTranslation();
  const { locales } = React.useContext(LocalesContext);
  const availableLocales = locales.join("|");
  return !checkUserPermissions(userRole, [UserRoles.User]) ? (
    <Switch>
      <Route
        exact
        path={`/:lng(${availableLocales})/dashboard/templates/:view(all|supervisor|individual|peer|anonymousDSV)`}
        component={Routes.TemplateList}
      />
      <Route
        exact
        path={`/:lng(${availableLocales})/dashboard/templates/:view/:templateId`}
        component={Routes.CreateUpdateTemplate}
      />
    </Switch>
  ) : (
    <PageError message={t(`feedback.pageNoPermission`)} />
  );
};
const mapStateToProps = ({ currentUser: { userData } }: IAppReduxState) => ({
  userRole: (userData as IExtendedUser).userRole as IUserRole
});
export default connect(mapStateToProps, null)(TemplatesView);
